import * as types from '../actions/actionTypes.js';
import initialState from "./initialState.js";

export function approvalReducer(
  state = initialState.tourApprovals, action
) {
  switch (action.type) {
    case types.FETCH_TOUR_APPROVALS_SUCCESS:
      return action.tourApprovals;
    default:
      return state;
  }
}

export function timeKeeperCheckForTourReducer(
  state = initialState.timeKeeperCheckForTour, action
) {
  switch (action.type) {
    case types.FETCH_TIME_KEEPER_REVERSALS_BY_RESOURCE_DAY_TYPE_ID:
      return action.reversal;
    default:
      return state;
  }
}

export function tourIsDirectBillingReducer(
  state = initialState.tourIsDirectBilling, action
) {
  switch (action.type) {
    case types.FETCH_TOUR_IS_DIRECT_BILLING_BY_TOUR_ID:
      return action.directBilling;
    default:
      return state;
  }
}

export function contactInfoForAssignmentReducer(
  state = initialState.contactInfoForAssignment, action
) {
  switch (action.type) {
    case types.FETCH_CONTACT_INFO_BY_TOUR_ID:
      return action.info;
    default:
      return state;
  }
}

export function tourReversalReducer(
  state = initialState.contactInfoForAssignment, action
) {
  switch (action.type) {
    case types.ADD_TOUR_REVERSAL:
      return action.response;
    default:
      return state;
  }
}

export function approvalParametersReducer(
  state = initialState.approvalParameters, action
) {
  switch (action.type) {
    case types.EDIT_APPROVAL_PARAMETERS_SUCCESS:
      return action.parameters;
    default:
      return state;
  }
}

export function branchesByCompanyIdReducer(
  state = initialState.branchesByCompanyId, action
) {
  switch (action.type) {
    case types.FETCH_BRANCHES_BY_COMPANY_ID_SUCCESS:
      return action.branches;
    default:
      return state;
  }
}

export function divisionsByBranchIdReducer(
  state = initialState.divisionsByBranchId, action
) {
  switch (action.type) {
    case types.FETCH_DIVISIONS_BY_BRANCH_ID_SUCCESS:
      return action.divisions;
    default:
      return state;
  }
}

export function departmentsByCompanyIdBranchIdDivisionIdReducer(
  state = initialState.departmentsByCompanyIdBranchIdDivisionId, action
) {
  switch (action.type) {
    case types.FETCH_DEPARTMENTS_BY_COMPANY_ID_BRANCH_ID_DIVISION_ID_SUCCESS:
      return action.departments;
    default:
      return state;
  }
}